import React from 'react';

interface FilterContentProps {
  children: React.ReactNode;
}

export const FilterContent: React.FC<FilterContentProps> = ({ children }) => {
  return (
    <div className="p-4">
      <ul className="space-y-4 text-sm">{children}</ul>
    </div>
  );
};
